import InfiniteWorld from "./infinite-world";
import SphericalWorld from "./spherical-world";
import CubicWorld from "./cubic-world";

class WorldBorderService {
    strategy;

    constructor() {
        this.strategy = new InfiniteWorld();
    }

    setWorld(isSpherical, {position, orientation, size}) {
        this.strategy = createWorld();

        function createWorld() {
            if (isSpherical) return new SphericalWorld(position, size);
            return new CubicWorld(position, orientation, size);
        }
    }

    resetWorld() {
        this.strategy = new InfiniteWorld();
    }

    limitToBorder(position) {
        this.strategy.limitToBorder(position);
    }
}

export default new WorldBorderService();
